// extracted by mini-css-extract-plugin
export default {"paragraph":"CardList_paragraph__rUgEH","cardList":"CardList_cardList__NmxZL","card":"CardList_card__IlCFV"};